var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0188 7.36325L20.0198 7.36423C20.7732 8.11866 20.8037 9.31825 20.0867 10.0372L11.2257 18.8983C10.9056 19.2184 10.4811 19.4163 10.03 19.4577L5.92304 19.831C5.8935 19.8339 5.86395 19.8349 5.83342 19.8349C5.57439 19.8349 5.32325 19.7325 5.1371 19.5463C4.93028 19.3395 4.82686 19.0519 4.85247 18.7614L5.22574 14.6544C5.26711 14.2043 5.46606 13.7788 5.78713 13.4587L14.6472 4.59866C15.3386 3.90432 16.5923 3.93879 17.3221 4.66662L20.0188 7.36325ZM16.6859 10.6547L14.0317 8.00047L15.9502 6.08092L18.6035 8.73422L16.6859 10.6547ZM9.85185 17.4958L6.91984 17.7627L7.17985 14.8514L12.712 9.31923L15.3672 11.9745L9.85185 17.4958Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3001_4126",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 17,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0188 7.36325L20.0198 7.36423C20.7732 8.11866 20.8037 9.31825 20.0867 10.0372L11.2257 18.8983C10.9056 19.2184 10.4811 19.4163 10.03 19.4577L5.92304 19.831C5.8935 19.8339 5.86395 19.8349 5.83342 19.8349C5.57439 19.8349 5.32325 19.7325 5.1371 19.5463C4.93028 19.3395 4.82686 19.0519 4.85247 18.7614L5.22574 14.6544C5.26711 14.2043 5.46606 13.7788 5.78713 13.4587L14.6472 4.59866C15.3386 3.90432 16.5923 3.93879 17.3221 4.66662L20.0188 7.36325ZM16.6859 10.6547L14.0317 8.00047L15.9502 6.08092L18.6035 8.73422L16.6859 10.6547ZM9.85185 17.4958L6.91984 17.7627L7.17985 14.8514L12.712 9.31923L15.3672 11.9745L9.85185 17.4958Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3001_4126)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.0da512ec22132dcbc616b9edf73c234e.svg";
export { ForwardRef as ReactComponent };